/**
 * El chip "Tengo una consulta rápida" → WhatsApp.
 *
 * Es el canal que eligió el equipo cuando el widget era sólo de un grupo chico de agencias
 * pioneras, con las que ya se hablaba por ahí, y el chat de soporte propio estaba acotado a las
 * agencias de dogfood. ⚠️ Las dos premisas caducaron: el chat está abierto a todas desde el
 * 2026-09-22 y el widget lo ve toda agencia con la UX 2.1 desde el 2026-09-30. Que el chip siga
 * yendo a WhatsApp es una decisión de producto a revisar (ver `FEEDBACK_WHATSAPP_URL` en el backend).
 *
 * Dos cosas que compensan lo que se pierde al salir del producto:
 *
 * 1. El mensaje llega **prellenado con la pantalla**, así el que atiende sabe de dónde viene. Todo
 *    lo demás que el widget captura (agencia, usuario, contexto) se pierde al cruzar a wa.me.
 * 2. Queda el CTA secundario "Enviarlo como feedback": la ruta nunca es un callejón sin salida
 *    para alguien que no quiere o no puede usar WhatsApp.
 */
import React from 'react';
import {useTranslation} from 'react-i18next';

export const FeedbackConsultaCard = ({whatsappUrl, whatsappMessage, screenPath}) => {
    const {t} = useTranslation();
    if (!whatsappUrl) return null;

    const message = screenPath ? `${whatsappMessage} (${screenPath})` : whatsappMessage;
    const href = `${whatsappUrl}?text=${encodeURIComponent(message || '')}`;

    return (
        <div className="feedback-card -consulta">
            <p className="feedback-card__title">{t('feedback.consulta.title')}</p>
            <p className="feedback-card__body">{t('feedback.consulta.body')}</p>
            <a className="feedback-whatsapp" href={href} target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z"/>
                </svg>
                {t('feedback.consulta.cta_whatsapp')}
            </a>
        </div>
    );
};

export default FeedbackConsultaCard;
